// Clients
export const SET_CLIENT = 'SET_CLIENT';

// Content
export const ADD_TAG = 'ADD_TAG';
export const UPDATE_TAG_STATUS = 'UPDATE_TAG_STATUS';
export const UPDATE_ALL_TAG_STATUS = 'UPDATE_ALL_TAG_STATUS';
export const CHANGE_PROCESSING_STATUS = 'CHANGE_PROCESSING_STATUS';
export const SET_CONTENT = 'SET_CONTENT';
export const UPDATE_CONTENT_TAG_CHANGED = 'UPDATE_CONTENT_TAG_CHANGED';
export const SET_BULK_SELECTED = 'SET_BULK_SELECTED';
export const ADD_CONTENT_ACTION = 'ADD_CONTENT_ACTION';
export const ADD_UNSAVED_CONTENT = 'ADD_UNSAVED_CONTENT';
export const REMOVE_UNSAVED_CONTENT = 'REMOVE_UNSAVED_CONTENT';

// Follows
export const UPDATE_FOLLOWS = 'UPDATE_FOLLOWS';

// Language
export const LOAD_LANGUAGE = 'LOAD_LANGUAGE';
export const ADD_LANGUAGE_FILE = 'ADD_LANGUAGE_FILE';
export const SET_CURRENT_LANGUAGE = 'SET_CURRENT_LANGUAGE';

// Navigation
export const SET_ACTIVE_QUICK_SEARCH = 'SET_ACTIVE_QUICK_SEARCH';
export const CLEAR_ACTIVE_QUICK_SEARCH = 'CLEAR_ACTIVE_QUICK_SEARCH';
export const SET_ACTIVE_WORKSPACE = 'SET_ACTIVE_WORKSPACE';
export const CLEAR_ACTIVE_WORKSPACE = 'CLEAR_ACTIVE_WORKSPACE';

// Pages
export const SET_PAGE = 'SET_PAGE';

// Queue
export const SET_QUEUE = 'SET_QUEUE';
export const SET_QUEUE_PROPERTY = 'SET_QUEUE_PROPERTY';
export const ADD_CONTENT_TO_QUEUE = 'ADD_CONTENT_TO_QUEUE';
export const REMOVE_CONTENT_FROM_QUEUE = 'REMOVE_CONTENT_FROM_QUEUE';
export const REMOVE_QUEUE = 'REMOVE_QUEUE';

// Quick Searches
export const SET_QUICK_SEARCH = 'SET_QUICK_SEARCH';
export const REMOVE_QUICK_SEARCH = 'REMOVE_QUICK_SEARCH';

// Searches
export const SET_SEARCH = 'SET_SEARCH';
export const SET_SEARCH_PROPERTY = 'SET_SEARCH_PROPERTY';
export const ADD_CONTENT_TO_SEARCH = 'ADD_CONTENT_TO_SEARCH';
export const REMOVE_CONTENT_FROM_SEARCH = 'REMOVE_CONTENT_FROM_SEARCH';
export const REMOVE_SEARCH = 'REMOVE_SEARCH';
export const PUSH_PREVIOUS_PAGE = 'PUSH_PREVIOUS_PAGE';
export const CLEAR_PREVIOUS_PAGES = 'CLEAR_PREVIOUS_PAGES';

// Sites
export const SET_SITE = 'SET_SITE';
export const SET_ACTIVE_SITE = 'SET_ACTIVE_SITE';

// Time
export const UPDATE_CURRENT_TIME = 'UPDATE_CURRENT_TIME';
export const UPDATE_PREVIOUS_TIME = 'UPDATE_PREVIOUS_TIME';
export const UPDATE_LAST_ACTIVE = 'UPDATE_LAST_ACTIVE';
export const SET_INACTIVE = 'SET_INACTIVE';
export const INCREMENT_TIME = 'INCREMENT_TIME';
export const RESET_TIME = 'RESET_TIME';
export const CLEAR_EVENT_HISTORY = 'CLEAR_EVENT_HISTORY';
export const ADD_EVENT_TO_HISTORY = 'ADD_EVENT_TO_HISTORY';

// Users
export const SET_USER = 'SET_USER';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';

// UI
export const INCREMENT_FULLSCREEN_OVERLAY = 'INCREMENT_FULLSCREEN_OVERLAY';
export const DECREMENT_FULLSCREEN_OVERLAY = 'DECREMENT_FULLSCREEN_OVERLAY';

// Workspaces
export const SET_WORKSPACE = 'SET_WORKSPACE';
export const SET_WORKSPACE_PROPERTY = 'SET_WORKSPACE_PROPERTY';
export const ADD_QUEUE_TO_WORKSPACE = 'ADD_QUEUE_TO_WORKSPACE';
export const ADD_SEARCH_TO_WORKSPACE = 'ADD_SEARCH_TO_WORKSPACE';
export const REMOVE_QUEUE_FROM_WORKSPACE = 'REMOVE_QUEUE_FROM_WORKSPACE';
export const REMOVE_SEARCH_FROM_WORKSPACE = 'REMOVE_SEARCH_FROM_WORKSPACE';
export const REMOVE_WORKSPACE = 'REMOVE_WORKSPACE';

// Version
export const SET_IS_OUT_OF_DATE = 'SET_IS_OUT_OF_DATE';
